// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trending-11 {\n  align-items: center;\n  background-color: var(--sea-serpent);\n  border-radius: 6px;\n  display: flex;\n  overflow: hidden;\n  padding: 16px 32px;\n  margin-top: 32px;\n}\n\n.trending-11:hover {\n  cursor: pointer;\n  background-color: var(--java);\n  transition: background-color 1s ease;\n}\n\n.begin-round {\n  letter-spacing: 0;\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
